import type { AxiosResponse } from 'axios';
import type { ThunkAction } from 'redux-thunk';

import ApiClient, { createTokenConfig, isCancelled } from 'api/ApiClient';
import store from 'store';
import { NotificationsAction, showError } from '@spike/notifications-action';

import {
    CUSTOM_ITEMS_INSIGHTS_REPORT_GET_ERROR,
    CUSTOM_ITEMS_INSIGHTS_REPORT_GET_START,
    CUSTOM_ITEMS_INSIGHTS_REPORT_GET_SUCCESS,
    CustomItemsInsightsReportAction
} from './CustomItemsInsightsReportActionsTypes';

import type { CustomItemsInsightsReportDto } from './CustomItemsInsightsReportDto';
import { convertToCustomItemsInsightsReport } from './customItemsInsightsReportConverter';
import type { CustomItemsInsightsReport } from 'model/CustomItemsInsightsReport';

export const getCustomItemsInsightsReport = (
    start?: string,
    end?: string,
    page?: number,
    perPage?: number
): ThunkAction<void, null, null, CustomItemsInsightsReportAction | NotificationsAction> => {
    return async dispatch => {
        dispatch(getStart());

        const { marketplaceId, token } = store.getState().login.auth;

        let url = `/custom_items_insights_report?marketplace_id=${marketplaceId}`;
        if (start) url += `&start=${start}`;
        if (end) url += `&end=${end}`;
        if (page) url += `&page=${page}`;
        if (perPage) url += `&per_page=${perPage}`;

        try {
            const response: AxiosResponse<CustomItemsInsightsReportDto> = await ApiClient.get(
                url,
                createTokenConfig(token!)
            );
            dispatch(getSuccess(convertToCustomItemsInsightsReport(response.data)));
        } catch (apiError) {
            if (!isCancelled(apiError)) {
                dispatch(getError());
                dispatch(showError('Could not load Custom Items insights report.'));
            }
        }
    };
};

const getStart = (): CustomItemsInsightsReportAction => ({
    type: CUSTOM_ITEMS_INSIGHTS_REPORT_GET_START
});

const getSuccess = (report: CustomItemsInsightsReport): CustomItemsInsightsReportAction => ({
    type: CUSTOM_ITEMS_INSIGHTS_REPORT_GET_SUCCESS,
    payload: { report }
});

const getError = (): CustomItemsInsightsReportAction => ({
    type: CUSTOM_ITEMS_INSIGHTS_REPORT_GET_ERROR
});
